import React, { useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import './App.css';
import Magical from './components/Magical';

function Home() {
  useEffect(() => {
    document.title = 'あんこの中の夢';
  }, []);

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center">
      <div className="text-center">
        <h1 className="text-4xl font-bold mb-8">あんこの中の夢</h1>
        <Link
          to="/magia-record-eye-catch"
          className="px-6 py-3 bg-blue-500 hover:bg-blue-600 text-white font-semibold rounded-lg inline-block mb-6"
        >
          魔法少女モード判別ツール
        </Link>
        <div className="mt-8">
          <a
            href="https://x.com/anko16384"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 px-4 py-2 bg-black hover:bg-gray-800 text-white rounded-lg transition-colors"
          >
            <svg className="w-5 h-5" fill="currentColor" viewBox="0 0 24 24">
              <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"/>
            </svg>
            @anko16384
          </a>
        </div>
      </div>
    </div>
  );
}

function Navigation() {
  const location = useLocation();
  
  if (location.pathname === '/') {
    return null;
  }
  
  return (
    <nav className="bg-white shadow-sm p-4">
      <Link
        to="/"
        className="text-blue-500 hover:text-blue-600"
      >
        ← ホームに戻る
      </Link>
    </nav>
  );
}

function App() {
  return (
    <Router>
      <div className="App">
        <Navigation />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/magia-record-eye-catch" element={<Magical />} />
        </Routes>
      </div>
    </Router>
  );
}

export default App;
